module.exports = __webpack_public_path__ + "img/logo-mongpress.ca360897.svg";